module.exports = __webpack_public_path__ + "images/2-3_3_News_Media.jpg?8c06e8a";


//////////////////
// WEBPACK FOOTER
// ./assets/images/news/2-3_3_News_Media.jpg
// module id = 177
// module chunks = 0